/**

  ___                       _      ___       _        
 |   \ _  _ _ _  __ _ _ __ (_)__  |   \ __ _| |_ __ _ 
 | |) | || | ' \/ _` | '  \| / _| | |) / _` |  _/ _` |
 |___/ \_, |_||_\__,_|_|_|_|_\__| |___/\__,_|\__\__,_|
       |__/
       
*/

import { VisionApplication } from '../application';
import { PublishTopic } from '../events';
import { PubSubManager } from '../pubsub';
import { BaseService } from './base';

export interface WorkspaceConfiguration {
    columns: (string | number)[];
    order: number[];
    widths: number[];
    cellWidth: number;
    mapType: string | undefined;
}

export interface WorkspaceDTO {
    id?: string;
    name?: string;
    layout?: string;
    panel: string;
    description?: string;
    shared?: boolean;
    defaultWorkspace?: boolean;
    //panelObject: any;
    config: WorkspaceConfiguration;
}

export class WorkspaceService extends BaseService {
    workspaces!: Map<string | undefined, WorkspaceDTO>;

    pubsub: PubSubManager;

    constructor(pubsub: PubSubManager) {
        super();
        this.pubsub = pubsub;
        this.workspaces = new Map<string | undefined, WorkspaceDTO>();
        this.loadWorkspaces();
    }

    public refresh() {
        this.workspaces.clear();
        const list = this.getWorkspaces();

        list.then((data) => {
            if (data.parsedBody) {
                data.parsedBody.forEach((workspace) => {
                    this.workspaces.set(workspace.id, workspace);
                });

                VisionApplication.getInstance().pubsub.publish(PublishTopic.WORKSPACES_RELOADED, this.workspaces);
            }
        });
    }

    public async init() {
        return new Promise((resolve, _reject) => {
            const list = this.getWorkspaces();

            list.then((data) => {
                if (data.parsedBody) {
                    console.log('Loading Workspaces');
                    data.parsedBody.forEach((workspace) => {
                        this.workspaces.set(workspace.id, workspace);
                    });
                }
                resolve('Loaded');
            });
        });
    }

    loadWorkspaces() {
        /*
        var request = this.getWorksapces();
        
        request.then ( (data) => {
            console.log("Loading Workspaces");
            if ( data.parsedBody != null ) {
                data.parsedBody.forEach ( (workspace)=> {
                    console.log("Workspace Name: " + workspace.name);
                    
                    workspace.panelObject = JSON.parse(workspace.panel);

                    this.workspaces.set(workspace.id, workspace);
                })
            }

            this.pubsub.publish(PublishTopic.WORKSPACES_LOADED, null);
        })
        */
    }

    async saveWorkspace(space: WorkspaceDTO) {
        const response = await this.post<WorkspaceDTO>(this.url + '/api/' + this.orgid + '/user/workspace', space);
        return response;
    }

    async updateWorkspace(space: WorkspaceDTO) {
        const response = await this.put<WorkspaceDTO>(this.url + '/api/' + this.orgid + '/user/workspace', space);
        return response;
    }

    async getWorkspaces() {
        const response = await this.get<WorkspaceDTO[]>(this.url + '/api/' + this.orgid + '/user/workspace');
        return response;
    }

    async deleteWorkspace(id: string) {
        const response = await this.delete<WorkspaceDTO>(this.url + '/api/' + this.orgid + '/user/workspace', id);
        return response;
    }
}
